<template>
    <div class="trading-desk-container portfolio-wrapper">
        <v-layout column wrap fill-height>
            <div class="loading-screen" v-if="isLoading">
                <v-img class="loading-gif" src="../assets/loading.gif"></v-img>
            </div>

            <div class="trading-desk-container1">
                <div class="wine-market-wrapper">
                    <div v-if="ordersLength > 0">
                        <v-row v-for="(orderItem, index) in groupedOrders" :key="orderItem.wineId + index" no-gutters
                               class="portfolio-row">
                            <div class="wine-details-head">
                                <div v-if="orderItem.wineName">
                                    <h2 v-on:click="() => $router.push('/wine-details/' + orderItem.wineId + '/' + orderItem.caseSizeId + '/' + orderItem.appellation.toLowerCase().split(' ').join('-') + '-' + orderItem.classification.toLowerCase().split(' ').join('-') + '-' + (orderItem.colorId === 1 ? 'red' : (orderItem.colorId === 2 ? 'white' : (orderItem.colorId === 3 ? 'rose' : 'champagne'))) + '-' + orderItem.vintage + '-' + orderItem.wineName.toLowerCase().split(' ').join('-') + '-' + orderItem.producerName.toLowerCase().split(' ').join('-') + '-' + orderItem.producerTypeName.toLowerCase().split(' ').join('-'))">
                                        {{ orderItem.vintage }} {{ orderItem.wineName }}</h2>
                                    <h3 v-if="orderItem.isSecondLabel" class="addition-description">2-nd label of
                                        {{ orderItem.producerTypeName }} {{ orderItem.producerName }}</h3>
                                    <h3 v-else class="addition-description">{{ orderItem.producerTypeName }}
                                        {{ orderItem.producerName }}</h3>
                                </div>
                                <div v-else>
                                    <h2 v-on:click="() => $router.push('/wine-details/' + orderItem.wineId + '/' + orderItem.caseSizeId + '/' + orderItem.appellation.toLowerCase().split(' ').join('-') + '-' + orderItem.classification.toLowerCase().split(' ').join('-') + '-' + (orderItem.colorId === 1 ? 'red' : (orderItem.colorId === 2 ? 'white' : (orderItem.colorId === 3 ? 'rose' : 'champagne'))) + '-' + orderItem.vintage + '-' + orderItem.producerName.toLowerCase().split(' ').join('-') + '-' + orderItem.producerTypeName.toLowerCase().split(' ').join('-'))">
                                        {{ orderItem.vintage }} {{ orderItem.producerTypeName }}
                                        {{ orderItem.producerName }}</h2>
                                </div>
                                <div class="second-row second-row-bids">
                                    <div v-if="orderItem.isEnPrimeur" class="wine-enprimeur">
                                        En Primeur
                                        <div class="info-text">{{
                                                $t('will-be-bottled')
                                            }}{{ orderItem.vintage.charAt(2) }}{{ parseInt(orderItem.vintage.charAt(3)) + 3 }}
                                        </div>
                                    </div>
                                    <div class="status">
                                        <span class="chip bid" v-if="orderItem.orderType === 'BID'">{{
                                                $t('bid')
                                            }}</span>
                                        <span class="chip offer" v-else>{{ $t('bo-offer') }}</span>
                                        <span class="chip cancelled" v-if="orderItem.status === 5"><span></span>{{
                                                $t('trade-history9')
                                            }}</span>
                                        <span class="chip expired" v-else-if="orderItem.status === 11"><span></span>{{
                                                $t('bo-expired')
                                            }}</span>
                                        <span class="chip active" v-else-if="orderItem.status === 1"><span></span>{{
                                                $t('bo-active')
                                            }}</span>
                                        <span class="chip expired" v-else><span></span>-</span>
                                    </div>
                                </div>
                            </div>

                            <div v-if="orderItem.orderType !== 'OFFER'">
                                <div class="mobile-wines-header">
                                    <div>{{ $t('case-size') }}</div>
                                    <div>{{ $t('cases') }}</div>
                                    <div>{{ $t('expires-in') }}</div>
                                    <div>{{ $t('price-per-case') }}</div>
                                    <div>{{ $t('buy13') }}</div>
                                    <div>{{ $t('storage') }}</div>
                                    <div>{{ $t('insurance') }}</div>
                                    <div>{{ $t('total-cost') }}</div>
                                </div>
                                <div class="mobile-wines-body">
                                    <div class="mobile-wines-row" v-for="item in orderItem.orders" :key="item.id">
                                        <div class="mobile-wines-div">{{ item.size }}</div>
                                        <div class="mobile-wines-div">{{ item.units }}</div>
                                        <div class="mobile-wines-div">
                                            {{ item.expireAfterDays ? `${item.expireAfterDays} days` : '-' }}
                                        </div>
                                        <div class="mobile-wines-div">{{
                                                item.price ? formatPrice(item.price.toLocaleString("fi-FI", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }).replace(',', '.')) : '-'
                                            }}
                                        </div>
                                        <div class="mobile-wines-div">
                                            {{
                                                formatPrice((item.commission + item.commissionVat).toLocaleString("fi-FI", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }).replace(',', '.'))
                                            }}
                                        </div>
                                        <div class="mobile-wines-div">
                                            {{
                                                item.storage ? formatPrice((item.storage + item.storageVat).toLocaleString("fi-FI", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }).replace(',', '.')) : '-'
                                            }}
                                        </div>
                                        <div class="mobile-wines-div">
                                            {{
                                                item.storage ? formatPrice((item.storage * 1.2).toLocaleString("fi-FI", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }).replace(',', '.')) : '-'
                                            }}
                                        </div>
                                        <div class="mobile-wines-div">
                                            {{
                                                item.insurance ? formatPrice((item.insurance + item.insuranceVat).toLocaleString("fi-FI", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }).replace(',', '.')) : '-'
                                            }}
                                        </div>
                                        <div class="mobile-wines-div">
                                            {{
                                                formatPrice(((item.price * item.units) + (item.commission * item.commissionVat) + item.storage + item.insurance).toLocaleString("fi-FI", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }).replace(',', '.'))
                                            }}
                                        </div>
                                        <div class="mobile-wines-div last-child">
                                            <div v-if="item.status === 5 || item.status === 11" class="perform-btn"
                                                 v-on:click="() => selectWine(item, true)">{{ $t('activate-bid') }}
                                            </div>
                                            <div v-else class="perform-btn"
                                                 v-on:click="() => { showDeleteModal(item.id, item.orderType) }">
                                                {{ $t('cancel-bid') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="orderItem.orderType === 'OFFER'">
                                <div class="mobile-wines-header">
                                    <div>{{ $t('case-size') }}</div>
                                    <div>{{ $t('cases') }}</div>
                                    <div>{{ $t('price-per-case') }}</div>
                                    <div>{{ $t('buy13') }}</div>
                                    <div>{{ $t('return') }}</div>
                                    <div>{{ $t('gain') }}</div>
                                </div>
                                <div class="mobile-wines-body">
                                    <div class="mobile-wines-row" v-for="(item, index) in orderItem.orders"
                                         :key="item.id">
                                        <div class="mobile-wines-div">{{ item.size }}</div>
                                        <div class="mobile-wines-div">{{ item.units }}</div>
                                        <div class="mobile-wines-div">{{
                                                item.price ? formatPrice(item.price.toLocaleString("fi-FI", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }).replace(',', '.')) : '-'
                                            }}
                                        </div>
                                        <div class="mobile-wines-div">
                                            {{
                                                formatPrice((item.commission + item.commissionVat).toLocaleString("fi-FI", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }).replace(',', '.'))
                                            }}
                                        </div>
                                        <div class="mobile-wines-div">
                                            {{
                                                formatPrice(item.return.toLocaleString("fi-FI", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }).replace(',', '.'))
                                            }}
                                        </div>
                                        <div class="mobile-wines-div">
                                            {{
                                                item.profit ? formatPrice(item.profit.toLocaleString("fi-FI", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }).replace(',', '.')) : '-'
                                            }}
                                        </div>
                                        <div class="mobile-wines-div last-child">
                                            <div v-if="item.status === 5 || item.status === 11" class="perform-btn"
                                                 v-on:click="() => selectWine(item, false)">{{ $t('activate-offer') }}
                                            </div>
                                            <div v-else class="perform-btn"
                                                 v-on:click="() => { showDeleteModal(item.id, 'offer') }">
                                                {{ $t('cancel-offer') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-row>
                    </div>
                    <div class="no-orders-info" v-if="ordersLength === 0">{{ $t('myportfolio10') }}</div>
                </div>
            </div>

            <v-dialog v-model="cancelBidModal" max-width="496px">
                <v-card class="bids-offers-modal">
                    <div class="warning-icon"></div>
                    <v-card-title>Are you sure you want to cancel your {{ cancelBidType }}?</v-card-title>

                    <v-card-actions>
                        <v-btn class="btn-primary btn-bid-proceed" text v-on:click="cancelOrder">Cancel
                            {{ cancelBidTypeFormatted }}
                        </v-btn>
                        <v-btn class="btn-secondary btn-bid-cancel" text v-on:click="cancelBidModal = false">
                            {{ $t('cancel') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {GPortfolio, GOrders, GWines} from '@/store/getters';
import {APortfolio, AOrders, AWines, AUser} from '@/store/actions';
import moment from 'moment';

export default {
    name: "Portfolio",
    data() {
        return {
            isLoading: false,
            groupedOrders: {},
            ordersLength: 0,
            cancelBidModal: false,
            cancelBidId: null,
            userBrowser: '',
            userDevice: ''
        }
    },
    computed: {
        ...mapGetters({
            portfolioValue: GPortfolio.GET_PORTFOLIO_VALUE,
            portfolioProfit: GPortfolio.GET_PORTFOLIO_TOTAL_PROFIT,
            portfolioSummary: GPortfolio.GET_PORTFOLIO_SUMMARY,
            favWinesList: GWines.GET_FAVOURITE_WINES,
            orders: GOrders.GET_BIDS_AND_OFFERS
        }),
        filteredItems() {
            return this.portfolioSummary.map(item => {
                let isWineInFavourites = false;

                this.favWinesList.forEach(wine => {
                    if (item.wineId === wine.wineId && item.caseSizeId === wine.caseSizeId) {
                        isWineInFavourites = true;
                    }
                });
                return Object.assign({isFavourite: isWineInFavourites}, item);
            })
        }
    },
    methods: {
        ...mapActions({
            loadWines: APortfolio.LOAD_WINES,
            loadWinesSummary: APortfolio.GET_PORTFOLIO_SUMMARY,
            loadFavWines: AWines.GET_FAVOURITE_WINES,
            getOrders: AOrders.GET_ORDERS,
            cancelOrderAsync: AOrders.CANCEL_ORDER
        }),
        fnBrowserDetect(){
            let userAgent = navigator.userAgent;
            let browserName;

            if (userAgent.match(/chrome|chromium|crios/i)){
                browserName = "Chrome";
            } else if(userAgent.match(/firefox|fxios/i)){
                browserName = "Firefox";
            }  else if(userAgent.match(/safari/i)){
                browserName = "Safari";
            } else if(userAgent.match(/opr\//i)){
                browserName = "Opera";
            } else if(userAgent.match(/edg/i)){
                browserName = "Edge";
            } else{
                browserName="No browser detection";
            }


            return browserName
        },
        getMobileOperatingSystem() {
            let userAgent = navigator.userAgent || navigator.vendor || window.opera;

            if (/windows phone/i.test(userAgent)) {
                return "Windows Phone";
            }

            if (/android/i.test(userAgent)) {
                return "Android";
            }

            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iOS";
            }

            return "unknown";
        },
        detectDeviceType() {
            let device;

            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                device = this.getMobileOperatingSystem();
            } else if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(navigator.userAgent)) {
                device = 'Tablet'
            } else {
                if (navigator.platform.indexOf('Win') !== -1) {
                    device = 'Windows'
                } else if (navigator.platform.indexOf('Mac') !== -1) {
                    device = 'Mac OS'
                } else if (navigator.platform.indexOf('Linux') !== -1) {
                    device = 'Linux'
                } else {
                    device = 'Desktop'
                }
            }

            return device
        },
        formatDate(date) {
            return moment(date).locale(this.$i18n.locale).format('DD MMM YYYY')
        },
        selectWine(item, isBuy) {
            this.wineId = item.wineId;
            this.$store.dispatch(AWines.SELECT_WINE_ID, {
                wineId: item.wineId,
                caseSize: item.caseSizeId,
                languageId: this.$i18n.locale
            });
            this.$store.dispatch(AWines.GET_WINE_DETAILS);
            this.$router.push(this.localePath({path: (isBuy ? '/wine-trading-buy/' : '/wine-trading-sell/') + item.wineId}));
        },
        showDeleteModal(id, type) {
            this.cancelBidId = id;
            this.cancelBidModal = true;
            this.cancelBidType = type;
        },
        goToLogin() {
            this.$router.push(this.localePath({path: '/login'}));
        },
        async cancelOrder() {
            await this.cancelOrderAsync({orderId: this.cancelBidId, browser: this.userBrowser, device: this.userDevice});
            this.cancelBidModal = false;
            this.cancelBidId = null;
            this.getOrders()
        },
        toggleFav(event, wine) {
            event.stopPropagation();
            let currWineId = wine.wineId;
            let currWineCaseSizeId = wine.caseSizeId;

            this.$store.dispatch(AWines.SWITCH_WINE_FAVOURITE, {wineId: wine}).then(x => {
                this.$store.dispatch(AWines.GET_FAVOURITE_WINES).then(
                    this.filteredItems.forEach(wine => {
                        if (wine.wineId === currWineId) {
                            let isWineInFavourites = false;

                            this.favWinesList.forEach(wine => {
                                if (currWineId === wine.wineId && currWineCaseSizeId === wine.caseSizeId) {
                                    isWineInFavourites = true;
                                }
                            });

                            wine.isFavourite = isWineInFavourites;
                            return true
                        }
                    })
                )
            });
        },
        goToWineDetails(item) {
            this.$store.dispatch(AWines.SELECT_WINE_ID, {
                wineId: item.wineId,
                caseSize: item.casesSizes[0].caseSizeId,
                languageId: this.$i18n.locale
            });
            this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                this.$router.push(this.localePath({path: '/wine-details/' + item.wineId + '/' + item.casesSizes[0].caseSizeId + '/' + item.appellation.toLowerCase().split(' ').join('-') + '-' + item.classification.toLowerCase().split(' ').join('-') + '-' + item.color.toLowerCase() + '-' + item.wine.toLowerCase().split(' ').join('-')}));
            })
        },
        returnStatus(id) {
            return (id === 11 ? 'Expired' : (id === 5 ? 'Canceled' : 'Active'))
        },
        formatPrice(price) {
            return `€ ${price}`
        },
    },
    created() {
        this.$store.dispatch(AUser.GET_USER_DATA).then(() => {
            this.isLogged = true;
            this.getOrders();
        })
    },
    mounted() {
        this.userBrowser = this.fnBrowserDetect();
        this.userDevice = this.detectDeviceType();
    },
    watch: {
        orders: {
            immediate: true,
            deep: true,
            handler(v) {
                if (this.orders.length) {
                    this.ordersLength = this.orders.length;
                    this.groupedOrders = {}
                    this.passedWineIds = []

                    this.orders.forEach((element) => {
                        if (this.passedWineIds.indexOf(`${element.wineId}x${element.orderType}x${this.returnStatus(element.status)}x${moment(element.createdOn).format('DD-MMM-YYYY')}`) > -1) {
                            this.groupedOrders[`${element.wineId}x${element.orderType}x${this.returnStatus(element.status)}x${moment(element.createdOn).format('DD-MMM-YYYY')}`].orders.push(element)
                        } else {
                            this.passedWineIds.push(`${element.wineId}x${element.orderType}x${this.returnStatus(element.status)}x${moment(element.createdOn).format('DD-MMM-YYYY')}`)
                            element.orders = []
                            element.orders.push(element)
                            this.groupedOrders[`${element.wineId}x${element.orderType}x${this.returnStatus(element.status)}x${moment(element.createdOn).format('DD-MMM-YYYY')}`] = element
                        }
                    })
                } else {
                    this.ordersLength = 0;
                }
            }
        }
    }
}
</script>

<style scoped>
.addition-description {
    font-family: Roboto, sans-serif;
    font-weight: normal;
    font-size: 16px;
    margin-top: 6px;
    margin-bottom: 0;
    color: var(--black);
}

.wine-enprimeur {
    background: #E2C477;
    text-align: center;
    width: 86px;
    height: 17px;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: rgba(0, 0, 0, 0.88);
    padding: 0;
    border-radius: 4px;
    position: relative;
}

.wine-enprimeur + .status {
    margin-left: 10px;
}

.mobile-wines-header {
    padding: 0 0 10px;
}

.mobile-wines-header div {
    color: rgba(0, 0, 0, 0.64) !important;
    font-size: var(--fs-small);
    /*font-weight: 300;*/
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    height: 20px;
    white-space: nowrap;
    display: inline-block;
    width: 33.33%;
}

.mobile-wines-row {
    padding: 15px 0;
    border-top: 1px solid #b2b2b2;
}

.mobile-wines-row:nth-child(even) {
    background: var(--semi-white);
}

.mobile-wines-div {
    display: inline-block;
    width: 33.33%;
    vertical-align: top;
    padding: 5px 0;
    font-size: 14px;
    line-height: 17px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.88);
}

.mobile-wines-div.last-child {
    width: 100%;
}

.bids-offers-modal h3 {
    margin-bottom: 16px;
    font-size: var(--fs-large);
}

.goto-market-btn {
    margin-top: 32px;
}

.btn-bid-proceed {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
    background: var(--brand);
    color: #ffffff;
}

.btn-bid-cancel {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
}

.btn-bid-cancel:hover {
    color: #ffffff;
}

.bids-offers-modal {
    padding: 32px 48px;
    text-align: center;
    background: #f6f6f6;
}

.bids-offers-modal .warning-icon {
    background: url('../assets/report_problem-24px.svg') no-repeat center;
    background-size: contain;
    width: 40px;
    height: 40px;
    margin: 0 auto;
}

.bids-title svg {
    margin-right: 5px;
    fill: #707070;
    position: relative;
    top: 4px
}

.offers-title svg {
    margin-right: 5px;
    fill: #707070;
    position: relative;
    top: 4px
}

.cancel-bid-body {
    text-align: center;
    justify-content: center;
    font-size: var(--fs-base);
}

.wine-details-head {
    display: block;
    width: 100%;
}

h3 {
    color: #707070;
    margin-bottom: calc(2 * var(--gutter));
}

h4 {
    color: #707070;
    margin-top: var(--gutter);
    margin-bottom: 3px;
}

.market-btn-col {
    width: 100px;
}

.half-padding-left {
    padding-left: calc(0.5 * var(--gutter));
}

.no-padding-right {
    padding-right: 0;
}

.half-padding-right {
    padding-right: calc(0.5 * var(--gutter));
}

.trading-desk-container1 {
    height: 100%;
}

.trading-desk-container1 .v-card__text {
    height: 100%;
    padding-bottom: 0;
}

.trading-desk-table-tabs {
    padding: 0 15px;
    height: 100%;
}

.trading-desk-table-tabs .v-tabs-bar {
    background-color: #F9F9F9 !important;
}

.trading-desk-table-tabs .theme--light.v-tabs-items {
    height: calc(100% - 50px);
    background: #FFFFFF;
    -webkit-box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .14), 0 1px 3px 0 rgba(0, 0, 0, .12) !important;
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .14), 0 1px 3px 0 rgba(0, 0, 0, .12) !important;
}

.loading-screen {
    position: absolute;
    width: 100%;
    height: 100%;
    background: var(--semi-white);
    z-index: 10;
}

.loading-gif {
    margin: 200px auto;
    width: 200px;
    height: 200px;
}

.portfolio-table {
    margin: 0;
    background-color: transparent;
    box-shadow: none !important;
}

.wine-market-table-header-ctrls {
    height: 75px;
    padding-top: 5px;
    background: #ffffff;
    border-bottom: 1px solid #EAEEF1;
}

.winemarket-search-filter {
    width: calc(100% - 30px);
    display: inline-block;
    border-radius: 3px;
    text-indent: 48px;
    padding-left: 25px;
    background: url('../assets/search_icon.png') no-repeat 40px 16px;
}

.wine-market-wrapper {
    height: 100%;
    padding-bottom: 32px;
    position: relative;
}

.winemarket-change.negative {
    color: #da443d;
}

.winemarket-change.negative div {
    width: 20px;
    height: 15px;
    background-size: contain;
    display: inline-block;
    top: 1px;
    margin-left: 5px;
    position: relative;
    background: url('../assets/sprite-web.png') no-repeat -60px -507px;
}

.winemarket-change.positive {
    color: #3BC34F;
}

.winemarket-change.positive div {
    width: 20px;
    height: 15px;
    background-size: contain;
    display: inline-block;
    top: 1px;
    margin-left: 5px;
    position: relative;
    background: url('../assets/sprite-web.png') no-repeat -60px -456px;
}

.winemarket-winecolor-img {
    width: 20px;
    height: 45px;
    position: relative;
    background: url('../assets/sprite-web.png') no-repeat -17px -544px;
    position: relative;
}

.winemarket-winecolor-img.redwine {
    background: url('../assets/red.png') no-repeat center right;
    background-size: contain;
}

.winemarket-winecolor-img.whitewine {
    background: url('../assets/sprite-web.png') no-repeat -17px -444px;
    background-size: contain;
}

.winecolor-tooltip {
    width: 80px;
    height: 25px;
    color: #182730;
    font-size: 13px;
    font-weight: 400;
    top: -15px;
    left: 8px;
    position: relative;
    background: #f9f9f9;
    border-radius: 5px;
    text-align: center;
    line-height: 25px;
    -webkit-box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.75);
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.75);
    display: none;
}

.winemarket-winecolor-img:hover .winecolor-tooltip {
    display: block;
}

.v-data-table tr:hover,
.v-data-table td:hover {
    cursor: pointer;
}

.order-success-text {
    text-align: center;
}

.close-order-success-modal {
    margin: 0 auto;
}

.show-hide-ctrl:hover {
    cursor: pointer;
    background-position-x: -41px;
}

.wine-star {
    width: 33px;
    height: 33px;
    background: url('../assets/star-not-selected.svg') no-repeat center;
    background-size: contain;
    display: block;
    margin: 0 auto;
}

.wine-star:focus,
.wine-star:active {
    outline: none;
}

.wine-star.active {
    background: url('../assets/star-selected.svg') no-repeat center;
    background-size: contain;
}

.wine-star.active:hover {
    opacity: 0.8;
}

.portfolio-wrapper h2 {
    color: var(--black);
}

.wine-details-head h2:hover {
    color: var(--brand);
    cursor: pointer;
}

.portfolio-wrapper .portfolio-row {
    margin-top: 64px;
}

.market-btn {
    width: 125px;
    font-weight: 300;
    text-align: center;
    line-height: 1em;
    height: 32px;
}

.portfolio-wrapper .second-row {
    font-weight: 300;
    line-height: 20px;
    color: #555555;
    margin: 10px 0;
}

.portfolio-wrapper .last-trade-el {
    display: inline-block;
}

.portfolio-wrapper .my-investments {
    width: 100%;
    height: 123px;
    border-radius: 8px;
    background-color: #E1C376;
    padding: 22px 50px;
    display: flex;
}

.info-text {
    background: #303030;
    border-radius: 6px;
    padding: 6px;
    color: #ffffff;
    text-align: center;
    font-size: 14px;
    position: absolute;
    right: -45px;
    height: 65px;
    margin-top: -76px;
    white-space: pre-line;
    display: none;
}

.info-text:before {
    content: "";
    position: absolute;
    top: 100%;
    right: 75px;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-top: 10px solid #303030;
    border-right: 7px solid transparent;
}

.second-row .status {
    display: flex;
    align-items: center;
}

.second-row .status .chip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid transparent;
    border-radius: 4px;
    padding: 0 6px;
    height: 18px;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
}

.second-row .status .chip > span {
    display: block;
    width: 10px;
    height: 10px;
    margin-right: 5px;
    border-radius: 1px;
}

.second-row .status .chip.bid {
    background-color: #004F7F;
    color: #FFF;
    width: 50px;
    height: 17px;
    padding: 0;
    text-align: center;
    display: inline-block;
    margin-right: 16px;
}

.second-row .status .chip.offer {
    color: #004F7F;
    border: 1px solid #004F7F;
    height: 17px;
    padding: 0 5px;
    text-align: center;
    display: inline-block;
    margin-right: 16px;
}

.second-row .status .chip.cancelled {
    border-color: rgba(213, 57, 79, 1);
    color: rgba(0, 0, 0, 0.88);
}

.second-row .status .chip.cancelled > span {
    background-color: rgba(213, 57, 79, 1);
}

.second-row .status .chip.expired {
    color: rgba(0, 0, 0, 0.88);
    border: 1px solid rgba(0, 0, 0, 0.38);
}

.second-row .status .chip.expired > span {
    background-color: rgba(0, 0, 0, 0.88);
}

.second-row .status .chip.active {
    color: rgba(0, 0, 0, 0.88);
    border: 1px solid #018671;
}

.second-row .status .chip.active > span {
    background-color: #018671;
}

.perform-btn {
    font-weight: 700;
    font-size: 16px;
    line-height: 150%;
    border: 1px solid var(--light-gray);
    border-radius: 4px;
    text-align: center;
    padding: 10px;
    margin-top: 4px;
}

.perform-btn:hover {
    cursor: pointer;
}

@media (max-width: 767px) {
    .portfolio-wrapper .portfolio-row {
        margin-top: 30px;
        background-color: #FFF;
        border-radius: 8px;
        padding: 8px;
    }

    .portfolio-wrapper h2 {
        font-size: 20px;
        line-height: 22px;
    }

    .market-btn {
        width: 100%;
    }

    .portfolio-wrapper .wine-details-img {
        width: 23px;
        height: 15px;
    }
}
</style>

<style>
.bids-offers-modal .v-card__title,
.bids-offers-modal .v-card__actions {
    justify-content: center;
}

.offers-table .hyperlink-td,
.bids-table .hyperlink-td {
    float: right;
}

.footer-info-text div {
    display: inline-block;
    margin-right: 25px;
}

.portfolio-wrapper .my-investments .investments-item {
    text-align: right;
    border-right: 1px solid #FADF95;
    padding-right: 15px;
    padding-left: 20px;
}

.portfolio-wrapper .my-investments .investments-label {
    color: #FBEAC0;
    margin-bottom: 5px;
}

.portfolio-wrapper .my-investments .bold {
    color: #fff;
    font-weight: 500;
    font-size: 36px;
}

.portfolio-wrapper .theme--light.v-data-table tbody tr td .dots {
    display: inline-block;
    width: 8px;
    height: 18px;
    margin: 0;
    background: url('../assets/dots-only-for-example.png') no-repeat center;
    background-size: contain;
    cursor: pointer;
    position: relative;
    top: 2px;
}

.portfolio-wrapper .theme--light.v-data-table thead tr th.gain-th:after {
    content: '';
    width: 15px;
    height: 15px;
    background: url('../assets/info-icon-for-example.png') no-repeat center;
    position: absolute;
    right: -15px;
    top: 15px;
    background-size: cover;
}

.portfolio-wrapper .v-data-table {
    box-shadow: none !important;
    width: 100%;
}

.portfolio-wrapper .last-trade-el-class {
    margin: 0 calc(1.5 * var(--gutter));
}

.portfolio-wrapper .winemarket-winecolor-img {
    display: inline-block;
    width: 20px;
    height: 16px;
    position: relative;
    margin: 0 0 0 calc(1.5 * var(--gutter));
    background: url('../assets/rose.png') no-repeat center;
    background-size: contain;
}

.portfolio-wrapper .winemarket-winecolor-img.redwine {
    background: url('../assets/red.png') no-repeat center;
    background-size: contain;
}

.portfolio-wrapper .winemarket-winecolor-img.whitewine {
    background: url('../assets/white.png') no-repeat center;
    background-size: contain;
}

.portfolio-wrapper .wine-details-img {
    width: 30px;
    height: 19px;
    border: 1px solid #DEE2E4;
    position: relative;
    top: 2px;
    margin-right: 10px;
}

.portfolio-wrapper .wine-details-region {
    max-width: var(--container-width);
}

.portfolio-wrapper .theme--light.v-data-table.v-data-table--fixed-header.default-table thead th {
    padding-bottom: 0;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .portfolio-tabs .v-tabs-bar {
    max-width: 100%;
    background: var(--semi-white);
    padding: 0;
    height: 48px;
}

.portfolio-tabs .v-tabs-slider {
    background-color: transparent;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .portfolio-tabs .v-tab {
    background: #F5F6F5;
    text-transform: capitalize;
    color: rgba(0, 0, 0, .64);
    font-weight: 700;
    font-size: calc(var(--fs-base) - 2px);
    min-width: 120px;
    padding: 0 16px;
    text-transform: uppercase;
    border-bottom: 1px solid #B9BAB9;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .portfolio-tabs .v-tab.v-tab--active {
    border: 0;
    background: var(--semi-white);
    border-bottom: 4px solid var(--blue);
    position: relative;
}

.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .portfolio-tabs .v-tab.v-tab--active:after {
    content: '';
    width: 100%;
    position: absolute;
    background: #fff;
    height: 1px;
    bottom: -1px;
    left: 0;
}

.my-profile-card .my-profile-vertical-tabs .portfolio-tabs .v-slide-group__content .v-tabs-slider-wrapper {
    border-bottom: 1px solid #B9BAB9;
    display: block;
    width: 100% !important;
}

.theme--light.v-data-table .v-data-table-header th.sortable[aria-sort="none"] .v-icon {
    display: none;
}

.theme--light.v-data-table.v-data-table--fixed-header.default-table.myportfolio-table thead th:hover {
    color: var(--blue) !important;
    cursor: default;
}

.my-profile-vertical-tabs .portfolio-tabs .v-window.v-item-group.theme--light {
    padding-left: 0;
}
</style>
